import { render } from "./select-dept.html?vue&type=template&id=6cbdd3a6&scoped=true&ts=true"
import script from "./select-dept.ts?vue&type=script&lang=ts"
export * from "./select-dept.ts?vue&type=script&lang=ts"

import "./select-dept.scss?vue&type=style&index=0&id=6cbdd3a6&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbdd3a6"]])

export default __exports__